import { render, staticRenderFns } from "./UserHrFiles.vue?vue&type=template&id=0558d68e&scoped=true"
import script from "./UserHrFiles.vue?vue&type=script&lang=js"
export * from "./UserHrFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0558d68e",
  null
  
)

export default component.exports